import { render } from "./test-form.vue?vue&type=template&id=09710db8&scoped=true"
import script from "./test-form.vue?vue&type=script&lang=js"
export * from "./test-form.vue?vue&type=script&lang=js"

import "./test-form.vue?vue&type=style&index=0&id=09710db8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09710db8"]])

export default __exports__